// src/features/learner/components/ContentRenderers/StoryRenderer.js
import React from 'react';
import { extractContentFromUnit, processCallouts } from '../../../../utils/contentHelpers';
import { getCurrentPageIndex } from '../../../../utils/navigationHelpers';
import { createTooltipHandlers } from '../../../../utils/tooltipHelpers';

export const StoryRenderer = ({ 
    unit, 
    currentInternalIndex = 0, 
    internalContent = [] 
}) => {
    const tooltipHandlers = createTooltipHandlers();
    
    // Extract content with improved fallback logic
    let content = '';
    
    // Handle page objects from internal pagination first
    if (unit.content && typeof unit.content === 'string' && unit.id && unit.id.includes('_page_')) {
        // This is a page object created by internal navigation
        content = unit.content;
    }
    // Handle original units with pages array
    else if (unit.pages && Array.isArray(unit.pages) && unit.pages.length > 0) {
        // Check if we're in internal navigation mode
        if (internalContent.length > 0) {
            // We're in internal navigation, the current unit should be a page object
            const pageIndex = Math.min(currentInternalIndex, unit.pages.length - 1);
            content = unit.pages[pageIndex];
        } else {
            // No internal navigation, just use first page
            content = unit.pages[0];
        }
    }
    // Handle original unit reference for page objects
    else if (unit.originalUnit && unit.originalUnit.pages && Array.isArray(unit.originalUnit.pages)) {
        // This is a page object, get the specific page content
        const pageIndex = getCurrentPageIndex(unit);
        content = unit.originalUnit.pages[pageIndex] || unit.originalUnit.pages[0];
    }
    // Regular story unit - try different possible content locations
    else if (unit.content) {
        content = extractContentFromUnit(unit.content);
    }
    // Try other possible content properties
    else if (unit.body) {
        content = unit.body;
    } else if (unit.text) {
        content = unit.text;
    } else if (unit.html) {
        content = unit.html;
    } else if (unit.description) {
        content = unit.description;
    }
    
    // Fallback if no content found
    if (!content) {
        content = '<p>No content available for this unit</p>';
    }

    // Get callouts for this unit - handle both direct callouts and original unit callouts
    const callouts = unit.callouts || (unit.originalUnit && unit.originalUnit.callouts) || [];
    
    // Determine current page index for callouts
    let currentPageIndex = 0;
    if (unit.id && unit.id.includes('_page_')) {
        // Extract page index from page object ID
        currentPageIndex = getCurrentPageIndex(unit);
    }
    
    // Process callouts if they exist
    let processedContent = content;
    if (callouts && callouts.length > 0) {
        processedContent = processCallouts(processedContent, callouts, currentPageIndex);
    }

return (
        <div className="content-container">
            <div className="story-content">
                <div className="story-body">
                    <div 
                        dangerouslySetInnerHTML={{ __html: processedContent }}
                        {...tooltipHandlers}
                    />
                </div>
            </div>
        </div>
    );
};